import Character from "@lss/common/src/shell/Character";
import { InstaProfileINT } from "../../src/components/insta/interfaces";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { alexProfilesPic } from "../helpers/alexInstaImages";



interface AlexPropertiesINT {
    hasInsta: boolean,
    // insta: InstaProfileINT,
    instaNickName: string,
    instaDescription: string,
    instaProfileImage: TimageINT & { key?: string; },
    instaFollowing: number,
    instaFollowers: number,
    mcWroteLoveU?: boolean,
}

const alexProperties: AlexPropertiesINT = {
    hasInsta: true,
    instaNickName: "lil_crazy_alex",
    instaDescription: `I love life, working out, and puppies 😘`,
    instaProfileImage: alexProfilesPic.alexInstaPortrait1,
    instaFollowers: 2,
    instaFollowing: 5,

};

const alex = new Character<AlexPropertiesINT>("Alex", alexProperties, "#FF63C7FF");











export {
    alex,
};